import { z } from 'zod';

/* Cube card 10292 — Unicom shelfwise snapshot rows of one SKU at one facility.
   Metabase serializes ClickHouse Int64 as floats, so counts are coerced. */
export const InventoryShelfRowSchema = z.object({
  shelf: z.string().nullable(),
  section: z.string().nullable(),
  inventory_type: z.string().nullable(),
  quantity: z.coerce.number(),
  quantity_blocked: z.coerce.number(),
  excess_quantity: z.coerce.number(),
  snapshot_at: z.string().nullable(),
});

export const InventoryShelvesSchema = z.array(InventoryShelfRowSchema);

export type InventoryShelfRow = z.infer<typeof InventoryShelfRowSchema>;
export type InventoryShelves = z.infer<typeof InventoryShelvesSchema>;

const nullableCount = z.coerce.number().nullable();

/* Cube card 10293 — one row per revision of a warehouse_inventory row that changed a
   stock field, newest first. prev_* are NULL on the row's first revision. */
export const InventoryStockHistoryRowSchema = z.object({
  rev: z.coerce.number(),
  changed_at: z.string().nullable(),
  changed_by: z.string().nullable(),
  portal: z.string().nullable(),
  req_path: z.string().nullable(),
  change_type: z.enum(['INSERT', 'UPDATE', 'DELETE']).nullable(),
  prev_warehouse_inventory: nullableCount,
  warehouse_inventory: nullableCount,
  prev_blocked_inventory: nullableCount,
  blocked_inventory: nullableCount,
  prev_front_inventory: nullableCount,
  front_inventory: nullableCount,
  prev_back_inventory: nullableCount,
  back_inventory: nullableCount,
  prev_in_stock: z.boolean().nullable(),
  in_stock: z.boolean().nullable(),
  prev_status: z.string().nullable(),
  status: z.string().nullable(),
});

export const InventoryStockHistorySchema = z.array(InventoryStockHistoryRowSchema);

export type InventoryStockHistoryRow = z.infer<typeof InventoryStockHistoryRowSchema>;
export type InventoryStockHistory = z.infer<typeof InventoryStockHistorySchema>;

/* Cube card 10297 — cart behind each cart item id referenced by a CART inventory block. */
export const InventoryCartBlockRowSchema = z.object({
  cart_item_id: z.coerce.number(),
  cart_id: z.coerce.number(),
  cart_status: z.string().nullable(),
  sales_channel: z.string().nullable(),
  channel: z.string().nullable(),
  source: z.string().nullable(),
});

export const InventoryCartBlocksSchema = z.array(InventoryCartBlockRowSchema);

export type InventoryCartBlockRow = z.infer<typeof InventoryCartBlockRowSchema>;
export type InventoryCartBlocks = z.infer<typeof InventoryCartBlocksSchema>;
